import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';

export interface GetAffiliatesParams {
  affiliateId?: string;
  planName?: string;
  planInterval?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?: number;
}

export interface AffiliateData {
  id: string;
  userName: string;
  userEmail: string;
  affiliateId: string;
  receiptId: string | null;
  planName: string | null;
  planInterval: string | null;
  planAmount: number | null;
  eventType: string;
  commissionAmountPaid: number;
  clickCommissionPaid: boolean;
  saleCommissionPaid: boolean;
  eventDate: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface GetAffiliatesResponse {
  data: AffiliateData[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

const getAffiliatesData = async (params: GetAffiliatesParams): Promise<GetAffiliatesResponse> => {
  const res = await axiosInstance.get(`/api/affiliates`, { params });
  return res.data;
};

export const useGetAffiliatesData = () => {
  return useMutation(getAffiliatesData);
};
